import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class ThreeDTilesOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var ThreeDTilesLayer = this.props.layer.layerHandel;
        ThreeDTilesLayer.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const Layer = this.props.layer;
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large find icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large disabled setting icon"></i>
                    </div>
                </div>                
            </div>
        );
    }
}
class ThreeDTilesLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            ThreeDTilesLayer:{}
        };   
        this.ThreeDTilesLayerChecked = this.ThreeDTilesLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.ThreeDTilesLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,ThreeDTilesLayer:{}});
            }            
        }
    }
    ThreeDTilesLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            window.main.OView.add3DTilesLayer({
                url: layer.URL,
                urlTemplate: "{URL}",
                callback: function (e,ThreeDTilesLayer) {
                    if(e){
                        ThreeDTilesLayer.goto();
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,ThreeDTilesLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,ThreeDTilesLayer:ThreeDTilesLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });                  
        }
        else{
            window.main.OView.removeLayer(this.state.ThreeDTilesLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,ThreeDTilesLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="ThreeDTilesLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.ThreeDTilesLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {ThreeDTilesLayer ,ThreeDTilesOption};